/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Theme } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';

export const useChangePlanParameterSuggestionsStyles = makeStyles((theme: Theme) => ({
  sectionTitle: {
    display: 'flex',
    margin: '30px 0 20px 0',
  },
  title: {
    color: theme.palette.text.primary,
    fontSize: '14px',
    lineHeight: '17px',
  },
  sectionContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
    height: '100%',
    width: '100%',
    marginTop: '10px',
  },
  suggestionsContainer: {
    display: 'flex',
    flexDirection: 'column',
    marginLeft: '4px',
  },
  formControlLabel: {
    '& .MuiTypography-body1': {
      color: '#2C333B',
      fontSize: '16px',
      lineHeight: '24px',
    },
  },
}));
